export const getCacheItem = function (key: any) {
  return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null
}
export const setCacheItem = function (key: any, value: any) {
  typeof window !== 'undefined' && window.localStorage.setItem(key, value)
}
export const removeCacheItem = function (key: any) {
  typeof window !== 'undefined' && window.localStorage.removeItem(key)
}

export const setLocalStorage = (key: string, value: string | number) => {
  window.localStorage.setItem(key, String(value))
}

export const getLocalStorage = (key: string) => {
  return window.localStorage.getItem(key)
}

export const clearLocalStorage = (key: string) => {
  window.localStorage.removeItem(key)
}
